<div class="product-carousel-wrapper">
    <div class="product-carusel-title">תוכניות לדוגמא</div>
    <div id="product-carousel-wrapper" class="custom-carusel">
      <div
        class="arrow-right-product-carusel"
        [ngClass]="{ 'arrow-disabled': !displayRightArrow }"
        (click)="moveRight()"
      >
        <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
      </div>
      <div
        class="arrow-left-product-carusel"
        [ngClass]="{ 'arrow-disabled': !displayLeftArrow }"
        (click)="moveLeft()"
      >
        <fa-icon [icon]="['fas', 'arrow-circle-left']"></fa-icon>
      </div>
      <div class="custom-carusel-row">
        <div
          *ngFor="
            let pic of productPictureItems;
            let i = index
          "
          class="carousel-pic"
          (click)="displayCurrentPicture(pic.Path)"
        >
          <img
            src="/assets/online_design/product_exemple/{{ pic.Path }}"
          />
        </div>
      </div>
    </div>
  </div>

  